export default "__VITE_ASSET__c9209a00__"